import "./App.css";
import KanbanBoard from "./components/KanbanBoard";

function App() {
  return (
    <div className="App">
      <h1>Kanban Board</h1>
      <KanbanBoard />
    </div>
  );
}

export default App;
